/*******************************************************
OPEN FIVE MAN MODAL
Used on the five man stats page for NBA.
********************************************************/

import buildModal from '../../universal/modal-window/build-modal';
import showErrorNotificationBar from '../../universal/error-handling/show-error-notification-bar';

export default async function openCourtOnOffModal(event) {
    const $button = $(event.currentTarget);
    const { team, court } = $button.data();

    const teamAbbr = team;
    const courtOnOff = court;

    // Get the list of excluded players who have already been added
    const excludedPlayers = [];
    $('.court-on-off-player').each((index, player) => {
        const $player = $(player);
        excludedPlayers.push($player.data('player'));
    });


    try {
        const response = await $.ajax({
            type   : 'GET',
            url    : `/basketball/ajax/get-court-on-off-team.php`,
            data   : {
                team: teamAbbr,
                court: courtOnOff,
                exclude: excludedPlayers,
            },
            timeout: 10000,
        });

        const { playersHTML, success } = response;

        // Build the title
        const modalTitle = `
        <div class="flex-row align-center">
            <img style="width:35px;margin-right:10px;" src="https://content.rotowire.com/images/teamlogo/basketball/100${teamAbbr}.png"> Add Player
        </div>`;

        // Build the content of the modal
        const modalContent = `
            <div class="modal__scroller">
                <div class="flex-col">
                    ${playersHTML}
                </div>
            </div>`;

        // Get the modal window HTML
        const modalHTML = buildModal({
            title    : modalTitle,
            content  : modalContent,
        });

        // Append the modal window to the page
        $('.page').append(modalHTML);
    }
    catch (error) {
        showErrorNotificationBar(error.message || 'We were unable to retrieve that info for you. Please try again.', 3000);
    }

}
